import { ROUTES } from "../../../routes";
import { formatMoney } from "../../billing/utils/money";
import { PaymentReminderCard } from "../models/PaymentReminderCard";

/** The card's amount in the reader's language: 4500 + EUR → "45,00 €" (de), "€45.00" (en). */
export const formatCardAmount = (card: PaymentReminderCard, language: string): string =>
  formatMoney(card.amountMinor, card.currency, language);

/** A calendar date (yyyy-MM-dd) in the reader's language, read as that date wherever the reader is. */
export const formatCardDate = (isoDate: string, language: string): string =>
  new Intl.DateTimeFormat(language, { day: "numeric", month: "long", year: "numeric", timeZone: "UTC" }).format(
    new Date(`${isoDate}T00:00:00Z`),
  );

/** The billing period (yyyy-MM) as month and year in the reader's language ("Mai 2026"). */
export const formatCardPeriod = (periodLabel: string, language: string): string | null => {
  const match = /^(\d{4})-(\d{2})$/.exec(periodLabel);
  if (!match) return null;
  return new Intl.DateTimeFormat(language, { month: "long", year: "numeric", timeZone: "UTC" }).format(
    new Date(Date.UTC(Number(match[1]), Number(match[2]) - 1, 1)),
  );
};

/** Staff open the payment row in Billing: the member's payments with that one unfolded. */
export const staffPaymentLink = (card: PaymentReminderCard, memberId: string): string =>
  `${ROUTES.BILLING}?${new URLSearchParams({ tab: "payments", memberId, paymentId: card.paymentId }).toString()}`;
